/**
 * Drag and drop service for file browser component
 * Handles drag and drop operations for moving files between folders
 */
import { getWorkspaceId } from "../../../shared/services/dbUtils";
// @deprecated Moving files is retired for the Adorans read-only workspace.
import yjsDocumentService from "../../../infrastructure/sync/YjsDocumentService";
import { createOperationMetadata } from "../../../shared/services/metadata/metadataUtils";

export const isValidDrop = (sourceNode, targetNode) => {
  if (!sourceNode?.isLeaf || !targetNode || targetNode.isLeaf) return false;
  const sourceParentPath = sourceNode.data.path.split('/').slice(0, -1).join('/');
  return sourceParentPath !== targetNode.data.path;
};

export const processDrop = (sourceNode, targetNode, {selectedFile, setSelectedFile, navigate, editorFileChanged, fileRenamedEvent}) => {
  try {
    if (!isValidDrop(sourceNode, targetNode)) return false;
    
    const [sourceFile, targetFolder] = [sourceNode.data.path, targetNode.data.path];
    const newFilePath = `${targetFolder}/${sourceFile.split('/').pop()}`;
    
    !targetNode.isOpen && targetNode.open();
    
    // Create metadata using utility function
    const metadata = createOperationMetadata({
      action: 'rename',
      fileName: newFilePath, 
      oldFileName: sourceFile
    });
    
    // Update metadata for this file before rename
    const workspaceId = getWorkspaceId();
    yjsDocumentService.updateMetadata(workspaceId, metadata, sourceFile);
    
    if (selectedFile?.name === sourceFile) {
      editorFileChanged.postMessage({
        fileName: newFilePath, 
        fileContent: selectedFile.content,
        oldFileName: sourceFile, 
        action: 'rename',
        metadata: metadata
      });
      setSelectedFile({...selectedFile, name: newFilePath});
      navigate(`/song/${encodeURIComponent(newFilePath)}`);
    } else {
      fileRenamedEvent.postMessage({
        oldFileName: sourceFile, 
        newFileName: newFilePath,
        fileName: newFilePath, 
        action: 'rename',
        metadata: metadata
      });
    }
    return true;
  } catch (error) {
    console.error('Error processing file drop:', error);
    return false;
  }
};
